<div class="backup-withholding-content" [formGroup]="form">
  @if (content.infoBox) {
    <div class="backup-withholding-info-box" data-cy="backup-withholding-info-box">
      <img src="assets/images/terms/light-bulb-icon.svg" alt="" aria-hidden="true" class="backup-withholding-info-icon" />
      <p class="c11n-text-sm backup-withholding-info-text">
        <b>{{ content.infoBox.boldText }}</b> {{ content.infoBox.text }}
      </p>
    </div>
  }

  @if (content.withholdingQuestion && content.withholdingOptions) {
    <fieldset class="backup-withholding-question-section" data-cy="backup-withholding-question-section">
      <legend class="c11n-text-md-bold backup-withholding-question-legend" data-cy="backup-withholding-question">
        <c11n-tooltip [labelText]="withholdingQuestionText" tooltipId="withholdingQuestionTooltip" direction="above">
          <span c11nTooltipContent>{{ content.withholdingQuestionTooltip }}</span>
        </c11n-tooltip>
      </legend>
      <label class="backup-withholding-radio-tile" for="backupWithholdingNo" data-cy="backup-withholding-option-no">
        <span class="backup-withholding-radio-tile__content">
          <c11n-chip [labelText]="content.withholdingOptions.no.badge" color="turquoise" action="none" size="small"></c11n-chip>
          <span class="c11n-text-md">{{ content.withholdingOptions.no.label }}</span>
        </span>
        <input class="backup-withholding-radio-tile__input" id="backupWithholdingNo"
          formControlName="withholding" type="radio" value="no" (change)="onWithholdingChange()" />
      </label>
      <label class="backup-withholding-radio-tile" for="backupWithholdingYes" data-cy="backup-withholding-option-yes">
        <span class="c11n-text-md">{{ content.withholdingOptions.yes.label }}</span>
        <input class="backup-withholding-radio-tile__input" id="backupWithholdingYes"
          formControlName="withholding" type="radio" value="yes" (change)="onWithholdingChange()" />
      </label>
    </fieldset>
    @if (isBlockedByYes) {
      <c11n-hint-error
        [hasError]="true"
        [errorText]="content.withholdingOptions.yes.errorText"
        hintErrorId="withholdingYesError"
        data-cy="backup-withholding-yes-error">
      </c11n-hint-error>
      <c11n-banner
        variant="error"
        size="medium"
        [hasCloseControl]="false"
        [headingText]="content.withholdingOptions.yes.bannerTitle"
        data-cy="backup-withholding-yes-banner">
        <span>
          {{ content.withholdingOptions.yes.bannerBodyStart }}
          <a c11n-link variant="primary-reinforced"
            [href]="content.withholdingOptions.yes.bannerLinkUrl"
            target="_blank"
            rel="noopener noreferrer">{{ content.withholdingOptions.yes.bannerLinkText }}</a>
          {{ content.withholdingOptions.yes.bannerBodyEnd }}
        </span>
      </c11n-banner>
    }
  }

  @if (content.callout) {
    <p class="c11n-text-md" data-cy="backup-withholding-callout">{{ content.callout }}</p>
  }

  @if (content.bullets?.length) {
  <ol class="backup-withholding-bullets">
    @for (bullet of content.bullets; track $index) {
      @if (isString(bullet)) {
        <li class="c11n-text-md" [innerHTML]="bullet" data-cy="backup-withholding-bullet"></li>
      } @else {
        <li class="c11n-text-md" data-cy="backup-withholding-bullet">
          @for (segment of bullet.segments; track $index) {
            @if (isLink(segment)) {
              <a c11n-link variant="primary-reinforced"
                [href]="segment.url" target="_blank" rel="noopener noreferrer">{{ segment.text }}</a>
            } @else {
              {{ segment }}
            }
          }
        </li>
      }
    }
  </ol>
  }

  @if (content.eSignature) {
    <div class="backup-withholding-esignature" data-cy="backup-withholding-esignature-section">
      <p class="c11n-text-md-bold backup-withholding-esignature-title" data-cy="backup-withholding-esignature-title">
        <c11n-tooltip [labelText]="content.eSignature.title" tooltipId="esignatureTooltip" direction="above">
          <span c11nTooltipContent>{{ content.eSignature.tooltip }}</span>
        </c11n-tooltip>
      </p>

      <div class="backup-withholding-esignature-full-name" data-cy="backup-withholding-fullname-field">
        <label c11n-label for="esignatureFullName" id="esignatureFullNameLabel">
          {{ content.eSignature.fullNameLabel }}
        </label>
        <c11n-input class="backup-withholding-esignature-input--readonly">
          <input c11nInput id="esignatureFullName" type="text"
            aria-labelledby="esignatureFullNameLabel"
            evidence-id="backupWithholdingFullName"
            [value]="clientName"
            readonly
            data-cy="backup-withholding-fullname-input" />
        </c11n-input>
      </div>

      <div class="backup-withholding-esignature-row" data-cy="backup-withholding-esignature-row">
        <div class="backup-withholding-esignature-col" data-cy="backup-withholding-ssn-field">
          <label c11n-label for="esignatureSSN" id="esignatureSSNLabel">
            {{ content.eSignature.ssnLabel }}
          </label>
          <c11n-input class="backup-withholding-esignature-input--readonly">
            <input c11nInput id="esignatureSSN" type="text"
              aria-labelledby="esignatureSSNLabel"
              [value]="ssn"
              readonly
              evidence-id="backupWithholdingSSN"
              data-cy="backup-withholding-ssn-input" />
          </c11n-input>
        </div>
        <div class="backup-withholding-esignature-col" data-cy="backup-withholding-tax-classification-field">
          <label c11n-label for="esignatureTaxClass" id="esignatureTaxClassLabel">
            {{ content.eSignature.taxClassificationLabel }}
          </label>
          <c11n-input class="backup-withholding-esignature-input--readonly">
            <input c11nInput id="esignatureTaxClass" type="text"
              aria-labelledby="esignatureTaxClassLabel"
              evidence-id="backupWithholdingTaxClassification"
              [value]="taxClassificationValue"
              readonly
              data-cy="backup-withholding-tax-classification-input" />
          </c11n-input>
        </div>
      </div>
    </div>
  }

  <div class="backup-withholding-cta-wrapper">
    @if (showAcceptedLabel) {
      <div class="backup-withholding-accepted-label" data-cy="backup-withholding-accepted-label">
        <c11n-icon
          [name]="'success-fill'"
          [size]="'medium'"
          [altText]="'Accepted'"
          class="backup-withholding-accepted-icon">
        </c11n-icon>
        <span class="c11n-text-md-bold" data-cy="backup-withholding-accepted-date">Accepted <span evidence-id="backupWithholdingAcceptedDate">{{ acceptedDate ? acceptedDate : '' }}</span></span>
      </div>
    } @else {
      <c11n-button
        [labelText]="acceptAndContinueLabel"
        [attr.disabled]="isBlockedByYes || null"
        (clickEvent)="onAcceptAndContinue()"
        data-cy="accept-btn-backup-withholding"
        class="accordion-button">
      </c11n-button>
    }
  </div>
</div>
